export default __webpack_public_path__ + "static/media/0_tutorial_uninformed_search.eb387714.png";